import type codeEn from "./code.en";

// محرّر الشيفرة للقوالب (specs 19).
const codeAr: Record<keyof typeof codeEn, string> = {
  "code.title": "محرّر الشيفرة",
  "code.back": "العودة إلى القوالب",
  "code.files": "الملفات",
  "code.filter_files": "تصفية الملفات",
  "code.open_files": "الملفات المفتوحة",
  "code.open_tab": "مفتوح في تبويب",
  "code.has_errors": "يحتوي على أخطاء",
  "code.modified": "معدّل",
  "code.modified_hint": "تغيّر عن القالب الأصلي",
  "code.file_actions": "إجراءات الملف",
  "code.add_file": "إضافة ملف",
  "code.upload_asset": "رفع ملف",
  "code.add_in": "إضافة ملف إلى {folder}",
  "code.create": "إنشاء الملف",
  "code.created": "تم إنشاء الملف",
  "code.template_type": "قالب لصفحة",
  "code.template_suffix": "اسم بديل",
  "code.file_name": "اسم الملف",
  "code.name_invalid": "استخدم أحرفاً إنجليزية صغيرة وأرقاماً و - و _ فقط.",
  "code.name_taken": "يوجد ملف بهذا الاسم.",
  "code.will_create": "سيُنشأ",
  "code.format": "تنسيق",
  "code.format.json": "قالب JSON (أقسام يمكن ترتيبها)",
  "code.format.liquid": "قالب Liquid",
  "code.format.section": "قسم",
  "code.format.section_group": "مجموعة أقسام (JSON)",
  "code.hint.layout": "الإطار الذي يحيط بكل قالب، مثل theme أو password.",
  "code.hint.templates": "اتركه فارغاً للقالب الافتراضي، أو سمِّ قالباً بديلاً (product.gift ← «gift»).",
  "code.hint.sections": "يبدأ بإعدادات وكتل وإعداد مسبق.",
  "code.hint.blocks": "كتلة يمكن أن تحتويها الأقسام. ابدأ بـ _ لكتلة خاصة.",
  "code.hint.snippets": "شيفرة Liquid قابلة لإعادة الاستخدام، تُضمَّن بـ {% render 'name' %}.",
  "code.hint.custom_pages": "تخطيط صفحة يختاره التاجر لصفحة في واجهة المتجر › الصفحات.",
  "code.hint.assets": "مع الامتداد: ‎.css أو ‎.js أو ‎.json أو ‎.svg أو ‎.txt أو ‎.liquid. ارفع الصور والخطوط والوسائط بدلاً من ذلك.",
  "code.hint.locales": "رمز اللغة، مثل ar أو en.default.",
  "code.hint.config": "",
  "code.rename": "إعادة تسمية",
  "code.rename_title": "إعادة تسمية الملف",
  "code.rename_hint": "الملفات التي تستخدم الاسم القديم لا تُحدَّث: راجعها بعد إعادة التسمية.",
  "code.renamed": "تمت إعادة تسمية الملف",
  "code.duplicate": "نسخ",
  "code.duplicate_title": "نسخ الملف",
  "code.save_first": "احفظ تغييراتك أو تجاهلها أولاً.",
  "code.delete": "حذف",
  "code.delete_title": "حذف الملف؟",
  "code.delete_body": "سيُحذف",
  "code.used_by": "مستخدم في {n} مواضع — ستتعطل:",
  "code.no_references": "لا شيء في القالب يشير إلى هذا الملف.",
  "code.delete_history": "يبقى سجلّه محفوظاً، ويمكنك استعادته من نقطة استعادة.",
  "code.deleted_toast": "تم حذف الملف",
  "code.page": "صفحة",
  "code.history": "الإصدارات السابقة",
  "code.history_hint": "اختر إصداراً لمقارنته بما في المحرّر.",
  "code.this_version": "هذا الإصدار",
  "code.editor_now": "في المحرّر الآن",
  "code.restore_version": "استعادة هذا الإصدار",
  "code.version_restored": "تمت استعادة الإصدار",
  "code.restore_label": "إصدار مستعاد",
  "code.current": "الحالي",
  "code.deleted": "محذوف",
  "code.system": "النظام",
  "code.close": "إغلاق",
  "code.snapshots": "نقاط الاستعادة",
  "code.snapshots_hint": "تحفظ نقطة الاستعادة كل ملفات القالب. يحصل القالب المنشور على نقطة يومياً إذا تغيّر، وقبل أي استعادة تُحفظ الحالة الحالية.",
  "code.snapshot_name": "الاسم، مثل: قبل بانر رمضان",
  "code.snapshot_create": "إنشاء نقطة استعادة",
  "code.snapshots_none": "لا توجد نقاط استعادة بعد.",
  "code.snapshot_auto": "نسخة يومية",
  "code.n_files": "{n, plural, zero {لا ملفات} one {ملف واحد} two {ملفان} few {# ملفات} many {# ملفاً} other {# ملف}}",
  "code.restore": "استعادة",
  "code.snapshot_restore_title": "استعادة القالب كاملاً؟",
  "code.snapshot_restore_body": "تعود كل الملفات إلى «{name}». تُحفظ الحالة الحالية كنقطة استعادة أولاً.",
  "code.snapshot_restored": "تمت استعادة القالب",
  "code.goto_file": "الانتقال إلى ملف",
  "code.goto_file_ph": "اكتب جزءاً من اسم الملف",
  "code.no_matches": "لا توجد ملفات مطابقة",
  "code.conflict_title": "تغيّر هذا الملف أثناء تحريرك له",
  "code.conflict_body": "حفظ {who} إصداراً أحدث من",
  "code.conflict_clean": "تغييراتك وتغييراتهم لا تتداخل، لذا دُمجت. راجع النتيجة ثم احفظ.",
  "code.conflict_markers": "عدد المواضع التي تغيّرت لدى الطرفين: {n}. وُضعت عليها علامات <<<<<<< و >>>>>>> — عدّلها على اليمين ثم احفظ.",
  "code.conflict_saved": "حفظه {who}",
  "code.conflict_merged": "النتيجة المدمجة (قابلة للتعديل)",
  "code.conflict_theirs": "تجاهل تغييراتي",
  "code.conflict_mine": "الكتابة فوقه بتغييراتي",
  "code.conflict_use_merged": "حفظ النسخة المدمجة",
  "code.conflict_label_mine": "تغييراتك",
  "code.someone": "شخص آخر",
  "code.markers_left": "عالج علامات <<<<<<< ======= >>>>>>> قبل الحفظ.",
  "code.live": "منشور",
  "code.draft": "مسودة",
  "code.development": "تطوير",
  "code.read_only": "للقراءة فقط",
  "code.also_editing": "يحرّرون هذا القالب أيضاً",
  "code.no_file": "لا ملف مفتوح",
  "code.wrap_on": "التفاف الأسطر الطويلة",
  "code.wrap_off": "بدون التفاف الأسطر",
  "code.dark": "محرّر داكن",
  "code.light": "محرّر فاتح",
  "code.download": "تنزيل القالب",
  "code.preview": "معاينة",
  "code.publish": "نشر",
  "code.publish_title": "نشر هذا القالب؟",
  "code.publish_body": "سيصبح {name} قالب متجرك المنشور، ويراه المتسوقون فوراً.",
  "code.published": "تم نشر القالب",
  "code.save": "حفظ",
  "code.saved": "تم الحفظ",
  "code.saved_with_errors": "{n, plural, one {حُفظ مع خطأ واحد — أصلحه قبل النشر} two {حُفظ مع خطأين — أصلحهما قبل النشر} few {حُفظ مع # أخطاء — أصلحها قبل النشر} many {حُفظ مع # خطأً — أصلحها قبل النشر} other {حُفظ مع # خطأ — أصلحها قبل النشر}}",
  "code.live_rejected": "لا يمكن حفظ القالب المنشور وفيه أخطاء، حتى يبقى متجرك يعمل. أصلح المشكلات أدناه.",
  "code.unsaved": "تغييرات غير محفوظة",
  "code.close_tab": "إغلاق {name}",
  "code.changed_by": "غيّره {who}",
  "code.load_theirs": "تحميل نسختهم",
  "code.find": "بحث واستبدال",
  "code.goto_line": "الانتقال إلى سطر",
  "code.fold_all": "طيّ الكل",
  "code.unfold_all": "فتح الكل",
  "code.format_failed": "تعذّر التنسيق: {msg}",
  "code.problems": "المشكلات",
  "code.check_theme": "فحص القالب",
  "code.no_problems": "لا توجد مشكلات.",
  "code.search_all": "البحث في كل الملفات",
  "code.search_ph": "النص المطلوب",
  "code.replace_ph": "استبداله بـ",
  "code.match_case": "مطابقة حالة الأحرف",
  "code.search": "بحث",
  "code.replace_all": "استبدال الكل",
  "code.replace_all_title": "الاستبدال في كل الملفات؟",
  "code.replace_all_body": "سيُستبدل {n} تطابقاً في {files} ملفات داخل المحرّر. لا يُحفظ شيء حتى تحفظ كل ملف.",
  "code.replaced": "تم الاستبدال في {files} ملفات — راجعها واحفظها",
  "code.n_results": "النتائج: {n} في {files} ملفات",
  "code.preview_page": "الصفحة المعروضة",
  "code.page.home": "الصفحة الرئيسية",
  "code.page.product": "منتج",
  "code.page.collection": "مجموعة",
  "code.page.cart": "السلة",
  "code.page.search": "البحث",
  "code.page.page": "صفحة",
  "code.page.blog": "المدونة",
  "code.page.404": "صفحة غير موجودة",
  "code.reload": "إعادة تحميل",
  "code.open_new_tab": "فتح في تبويب جديد",
  "code.close_preview": "إغلاق المعاينة",
  "code.preview_hint": "تعرض التغييرات المحفوظة وتُحدَّث بعد كل حفظ.",
  "code.open_asset": "فتح الملف",
  "code.asset_hint": "لا يمكن تعديل الصور والخطوط والوسائط هنا. ارفع ملفاً جديداً بالاسم نفسه لاستبداله.",
  "code.uploaded": "تم رفع {name}",
  "code.empty_title": "افتح ملفاً لبدء التحرير",
  "code.empty_live": "هذا قالبك المنشور: يظهر ما تحفظه في متجرك مباشرة، ولا يمكن حفظ ملفات فيها أخطاء.",
  "code.empty_draft": "هذا القالب غير منشور. عاين تغييراتك ثم انشره عندما يكون جاهزاً.",
  "code.leave_body": "في بعض الملفات تغييرات غير محفوظة. هل تريد المغادرة دون حفظ؟",
  "code.discard_title": "تجاهل التغييرات؟",
  "code.discard_body": "تغييراتك على {path} غير محفوظة.",
  "code.discard": "تجاهل",
};
export default codeAr;
